import { getLegacyEnvVariable } from '@/app/components/LegacyEnvVariables/util';

export function getAssetUrl(url: string): string {
  return '/assets' + url;
}

export function getBuildAssetUrl(path: string): string {
  return (getLegacyEnvVariable('NEXT_PUBLIC_APP_ASSET_PREFIX') ?? '') + path;
}
